<template>
  <div
    class="lv-tooltip-button"
    :class="{ red: red, background: background, notAllow: notAllow }"
    @click="$_onClick($event)"
    @mouseenter="$_onMouseEnter"
    @mouseleave="$_onMouseLeave"
  >
    <LoadingAnimate v-if="isLoading" primary class="ml-7 mr-7" />
    <i v-else-if="active" class="lv-tooltip-button_icon" :class="activeIcon" />
    <i v-else class="lv-tooltip-button_icon" :class="[icon, { gray: gray }]" />
    <div
      v-if="activeTooltipText || tooltipText"
      ref="tooltipWrap"
      class="lv-tooltip-wrap"
      :class="{ longWidth: longWidth, left }"
      :style="tooltipStyle"
    >
      <p v-if="active" class="lv-tooltip_text">
        {{ $t(activeTooltipText) }}
      </p>
      <p v-else class="lv-tooltip_text">
        {{ $t(tooltipText) }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LvTooltipButton',
  props: {
    activeIcon: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    activeTooltipText: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    background: {
      type: Boolean,
      default: false,
    },
    longWidth: {
      type: Boolean,
      default: false,
    },
    gray: {
      type: Boolean,
      default: false,
    },
    notAllow: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      tooltipStyle: {},
    };
  },
  methods: {
    $_startLoading() {
      this.isLoading = true;
    },
    $_stopLoading() {
      this.isLoading = false;
    },
    $_onMouseEnter() {
      this.$nextTick(() => {
        this.$_adjustTooltipPosition();
      });
    },
    $_onMouseLeave() {
      this.tooltipStyle = {};
    },
    $_adjustTooltipPosition() {
      if (!this.$refs.tooltipWrap) {
        return;
      }
      const tooltip = this.$refs.tooltipWrap;
      const button = this.$el;
      const scrollContainer = this.$_findScrollContainer(button);

      if (!scrollContainer) {
        this.tooltipStyle = {};
        return;
      }

      const originalOpacity = tooltip.style.opacity;
      const originalVisibility = tooltip.style.visibility;
      tooltip.style.opacity = '1';
      tooltip.style.visibility = 'visible';

      const buttonRect = button.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const tooltipWidth = tooltipRect.width || tooltip.offsetWidth || tooltip.scrollWidth;

      tooltip.style.opacity = originalOpacity;
      tooltip.style.visibility = originalVisibility;

      const buttonCenterX = buttonRect.left + buttonRect.width / 2;
      const containerLeft = containerRect.left;
      const containerRight = containerRect.right;

      let tooltipLeftEdge;
      let tooltipRightEdge;
      let finalLeft;
      let finalTransform;

      if (this.left) {
        tooltipLeftEdge = buttonCenterX - 50 - tooltipWidth;
        tooltipRightEdge = buttonCenterX - 50;

        if (tooltipLeftEdge < containerLeft) {
          const offsetLeft = containerLeft - buttonRect.left + 5;
          finalLeft = offsetLeft + 'px';
          finalTransform = 'none';
        } else {
          finalLeft = '-50px';
          finalTransform = 'none';
        }
      } else {
        tooltipLeftEdge = buttonCenterX - tooltipWidth / 2;
        tooltipRightEdge = buttonCenterX + tooltipWidth / 2;

        if (tooltipLeftEdge < containerLeft) {
          const offsetLeft = Math.max(5, containerLeft - buttonRect.left + 5);
          finalLeft = offsetLeft + 'px';
          finalTransform = 'none';
        } else if (tooltipRightEdge > containerRight) {
          const offsetRight = containerRight - buttonRect.left - tooltipWidth - 5;
          if (offsetRight < 5) {
            finalLeft = '5px';
            finalTransform = 'none';
          } else {
            finalLeft = offsetRight + 'px';
            finalTransform = 'none';
          }
        } else {
          finalLeft = '50%';
          finalTransform = 'translateX(-50%)';
        }
      }

      this.tooltipStyle = {
        left: finalLeft,
        transform: finalTransform || '',
      };
    },
    $_findScrollContainer(element) {
      let parent = element.parentElement;
      let scrollContainer = null;
      while (parent && parent !== document.body) {
        const style = window.getComputedStyle(parent);
        if (
          style.overflowX === 'auto' ||
          style.overflowX === 'scroll' ||
          style.overflow === 'auto' ||
          style.overflow === 'scroll'
        ) {
          scrollContainer = parent;
          break;
        }
        parent = parent.parentElement;
      }
      if (!scrollContainer) {
        scrollContainer = document.body;
      }
      return scrollContainer;
    },
    $_onClick($event) {
      if (this.notAllow || this.isLoading) return;
      this.$emit('click', $event);
    },
  },
};
</script>
